import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import 'powerbi-client';
import './plugins/vuetify';
import './veeValidator/customValidator';
import './vueGoogleMaps/vueGoogleMaps';
import infiniteScroll from 'vue-infinite-scroll';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import vuescroll from 'vuescroll';
import App from './App.vue';
import router from './routes/router';
import store from './store/store';
import upperCamelCase from '../bin/uppercamelcase';
import 'theme/global.scss';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import Vidle from 'v-idle';

Vue.use(Vidle)

Vue.use(infiniteScroll);

Vue.use(vuescroll);

const requireComponent = require.context('../packages', true, /\/.*.js$/);
const dsnURL = process.env.VUE_APP_URL_DSN;

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperCamelCase(fileName.replace(/(\/[^/]*).*/, '$1')).substring(1);


  Vue.component(componentName, componentConfig.default || componentConfig);
});


Vue.config.productionTip = false;

export const eventBus = new Vue();

new Vue({
  router,
  store,
  VueCarousel,
  render: h => h(App)
}).$mount('#app');

/*Sentry.init({
  dsn: dsnURL,
  integrations: [new VueIntegration({ Vue, attachProps: true })]
});*/
